<template>
    <div>
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-info-circle"></i>
                  <h2 class="card-big-info-title">Info</h2>
                  <p class="card-big-info-desc">Glavne informacije o listi želja.</p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Komitent</label
                    >
                    <div class="col-lg-4 col-xl-3">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :value="user.companyTitle"
                        readonly
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center"
                    v-if="user.companyCode"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Šifra kupca</label
                    >
                    <div class="col-lg-4 col-xl-3">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :value="user.companyCode"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >B2B/B2C</label
                    >
                    <div class="col-lg-4 col-xl-3">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :value="user.b2B ? 'B2B' : 'B2C'"
                        readonly
                      />
                    </div>
                  </div>
  
                  <div class="form-group row align-items-center">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Ime i prezime
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :value="[user.firstName, user.lastName].filter(Boolean).join(' ')"
                        readonly
                      />
                    </div>
                  </div>
  
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
  
      <div class="row mt-4">
        <div class="col">
          <div class="card card-modern card-modern-table-over-header">
            <div class="card-header">
            </div>
            <div class="card-body">
              <div>
                <table
                  class="table table-ecommerce-simple table-borderless table-striped mb-0"
                  style="min-width: 640px"
                >
                  <thead>
                    <tr>
                      <th>RBR</th>
                      <th>Šifra</th>
                      <th>Naziv</th>
                      <th>Cijena</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(item, index) in articles" 
                      :key="item.id"
                    >
                      <td
                      >
                        {{ index + 1 }}
                      </td>
                      <td
                      >
                        <strong>{{ item.code }}</strong>
                      </td>
                      <td
                      >
                        <strong>{{ item.title }}</strong>
                      </td>
                      <td
                      >
                        {{ item.price | money2 }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <hr class="solid opacity-4" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import moment from 'moment';
  
  import { translations, pager } from '@/mixins';
  import config from '@/config';
  
  export default {
    name: 'EditWishList',
    mixins: [translations, pager],
    data() {
      return {
        deleteActionName: 'toBeDefined',
      };
    },
    computed: {
      user() {
        return this.$store.getters.getSelectedUser
      },
      articles() {
        return this.$store.getters.getWishList;
      },
      wishList() {
        return this.$store.getters.getWishList;
      },
      baseUrl() {
        return config.baseUrl;
      },
    },
    methods: {
      formatMomentDate(date, dateFormat = 'DD.MM.yyyy, HH:mm') {
        const formattedDate = moment.utc(date).local().format(dateFormat);
        return formattedDate;
      },
      loadWishList(id) {
        this.$store.commit('SELECT_USER', {});
        this.$store.commit('INIT_WISH_LIST_ARTICLES', []);
        this.$store.dispatch('getUser', id);
        this.$store.dispatch('getWishListItems', id);
      },
    },
    watch: {
      '$route.params.id': {
        immediate: true,
        handler(id) {
          this.loadWishList(parseInt(id, 10));
        },
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .product-img-thumb {
    width: 70px;
    height: auto;
  }
  
  .select-padding {
    padding: 0;
  }
  
  .form-group + .form-group {
    border-top: none;
  }
  
  .form-control[readonly] {
    background-color: #fff;
  }
  
  .billing-shipping tr td:first-child {
    width: 30%;
  }
  
  .title-icon {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .title-icon i {
    color: #212529;
    font-size: 16px;
  }
  
  .mr-2 {
    margin-right: 3px;
  }
  
  .stock-amount {
    background-color: #ffbbbb !important;
    box-shadow: none;
  }
  </style>
  <style lang="scss">
  #add-article,
  #edit-article {
    .modal-md-2.modal-dialog {
      min-width: 620px;
  
      .card-body {
        padding: 0 0.5em;
        box-shadow: none;
      }
    }
  
    // Ostatak stila za ove ID-ove
    .header-center {
      position: relative;
    }
  
    .article-list {
      position: absolute;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      list-style: none;
      padding: 0;
      z-index: 1020;
      left: 0;
      top: 40px;
      width: 100%;
      background: #fff;
      max-height: 450px;
      overflow-y: auto;
  
      li {
        display: block;
        border-top: 1px solid #ced4da;
        padding: 5px;
        cursor: pointer;
        overflow: hidden;
        opacity: 0.75;
  
        &:first-child {
          border-top: none;
        }
  
        &:hover {
          opacity: 1;
          .article-title {
            color: #259ddf;
            text-decoration: underline;
          }
        }
      }
    }
  
    .article-wrapper {
      display: flex;
      flex-basis: 50%;
    }
  
    .article-description {
      display: flex;
      flex-direction: column;
      height: 80px;
      color: #777;
    }
  
    .article-image {
      width: 80px;
      height: 80px;
      object-fit: cover;
      margin-right: 5px;
    }
  
    .product-image {
      display: block;
      width: 70px;
      height: 70px;
    }
  
    .product-image-container {
      margin-right: 5px;
    }
  
    .article-title,
    .article-code,
    .article-price {
      width: 100%;
      font-size: 16px;
      flex-basis: 50%;
    }
  }
  </style>
  